import React, { useState, useCallback } from "react";
import classnames from "classnames";
import { makeStyles, createStyles } from "@material-ui/core";
import { ISeatInfo } from "../../interface/IShareInfo";
import { Text } from "../Ui/Text";

interface IProps {
  seatInfo: ISeatInfo | undefined;
  loading: boolean;
}

const useStyles = makeStyles(({ palette }) => {
  return createStyles({
    rowContainer: {
      display: "flex",
      alignItems: "baseline",
      justifyContent: "space-around",
      width: "100%"
    },
    headingRowContainer: {
      paddingTop: 20
    },
    contentRowContainer: {
      paddingTop: 10
    },
    text: {
      fontSize: 14,
      fontWeight: 600,
      color: "#535353",
      textAlign: "center",
      lineHeight: "1.4"
    },
    seatInfoHeader: {
      marginBottom: "5px"
    },
    seatInfoColBlock: {
      maxWidth: "33%",
      overflowWrap: "break-word"
    }
  });
});

const SeatInfoComponent = ({ seatInfo, loading }: IProps) => {
  const classes = useStyles({});

  return (
    <React.Fragment>
      <div
        className={classnames(
          classes.headingRowContainer,
          classes.rowContainer
        )}
      >
        <div className={classes.seatInfoColBlock}>
          <Text
            variant="body1"
            className={classnames(classes.seatInfoHeader, classes.text)}
          >
            Section
          </Text>
          <Text variant="body1" className={classes.text}>
            {seatInfo ? seatInfo.sectionNumber : ""}
          </Text>
        </div>
        <div className={classes.seatInfoColBlock}>
          <Text
            variant="body1"
            className={classnames(classes.seatInfoHeader, classes.text)}
          >
            Row
          </Text>
          <Text variant="body1" className={classes.text}>
            {seatInfo ? seatInfo.rowNumber : ""}
          </Text>
        </div>
        <div className={classes.seatInfoColBlock}>
          <Text
            variant="body1"
            className={classnames(classes.seatInfoHeader, classes.text)}
          >
            Seat
          </Text>
          <Text variant="body1" className={classes.text}>
            {seatInfo ? seatInfo.seatNumber : ""}
          </Text>
        </div>
      </div>
    </React.Fragment>
  );
};

export const SeatInfo = SeatInfoComponent;
